import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-lawyer-level-create-edit',
  templateUrl: './lawyer-level-create-edit.component.html',
  styleUrls: ['./lawyer-level-create-edit.component.scss']
})
export class LawyerLevelCreateEditComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
